import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useRef, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";

const YclSponsors = () => {
    const [loading, setLoading] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const fileInputRef = useRef(null);

    const [sponsorId, setSponsorId] = useState(0);
    const [sponsors, setSponsors] = useState([]);
    const [categories, setCategories] = useState([]);


    const [formData, setFormData] = useState({
        sponsorId: 0,
        category: "",
        title: "",
        file: null,
    });

    // =====================================================
    // ✅ Fetch All Sponsors
    // =====================================================
    const fetchYclSponsor = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${baseurl}${API_URL.getYclSponsor}`);

            if (res?.data?.status === true) {
                setSponsors(res.data?.data || []);
            }
        } catch (err) {
            toast.error("Failed to load sponsors");
        } finally {
            setLoading(false);
        }
    };

    const fetchYclSponsorCategory = async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getYclSponsorCategory}`);

            if (res.data.status === true) {
                setCategories(res.data.data || []);
            }
        } catch (err) {
            toast.error("Failed to load sponsor category!");
        }
    };

    useEffect(() => {
        fetchYclSponsor();
        fetchYclSponsorCategory();
    }, []);

    // =====================================================
    // Handle Input Change
    // =====================================================
    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: type === "file" ? files[0] : value,
        }));
    };

    // =====================================================
    // Submit Add / Edit Sponsor
    // =====================================================
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const fd = new FormData();
            Object.keys(formData).forEach((key) => {
                fd.append(key, formData[key]);
            });

            const res = await axios.post(
                `${baseurl}${API_URL.saveYclSponsor}`,
                fd,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (res.data.status === true) {
                toast.success(
                    sponsorId ? "Sponsor updated successfully!" : "Sponsor created successfully!"
                );
                setIsFormOpen(false);
                fetchYclSponsor();
                handleClose();
            } else {
                toast.error(res.data.message || "Failed to save sponsor");
            }
        } catch (err) {
            toast.error("Error saving sponsor. Please try again.");
        }
    };

    // =====================================================
    // Edit Sponsor
    // =====================================================
    const handleEdit = (item) => {
        setSponsorId(item.id);
        setIsFormOpen(true);

        setFormData({
            sponsorId: item.id,
            category: item.category,   // category = categoryId returned from API
            title: item.title,
            file: null,
        });
    };

    // =====================================================
    // Delete Sponsor
    // =====================================================
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this sponsor?")) return;

        try {
            const res = await axios.delete(`${baseurl}${API_URL.deleteYclSponsor}?id=${id}`);

            if (res.data.status === true) {
                toast.success("Sponsor deleted successfully!");
                fetchYclSponsor();
            }
        } catch {
            toast.error("Error deleting sponsor.");
        }
    };

    // =====================================================
    // Reset Form
    // =====================================================
    const handleClose = () => {
        setIsFormOpen(false);
        setSponsorId(0);
        setFormData({
            sponsorId: 0,
            category: "",
            title: "",
            file: null,
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    // =====================================================
    // Columns for Table
    // =====================================================
    const columns = [
        { name: "S.No", selector: (_, i) => i + 1, width: "70px" },

        {
            name: "Image",
            selector: (row) => (
                <img src={row.imageUrl} alt="img" style={{ height: "40px" }} />
            ),
        },

        { name: "Category", selector: (row) => row.categoryName },
        { name: "Title", selector: (row) => row.title },

        {
            name: "Action",
            cell: (row) => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => handleEdit(row)} title='Edit' className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#ff7722" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="#ff7722" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span onClick={() => handleDelete(row?.id)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">YCL Sponsors</h4>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="add_btn">
                            <button onClick={() => setIsFormOpen(true)}>Add Sponsors</button>
                        </div>
                    </div>
                </div>

                {/* Table */}
                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={sponsors}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                    />
                </div>

                {/* Form Modal */}
                <div className={`adminform entryform ${isFormOpen ? "open" : ""}`}>
                    <div className="closebtn">
                        <button onClick={handleClose}>
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>

                    <div className="enForm">
                        <h4 className="text-center">
                            {sponsorId ? "Edit Sponsor" : "Add Sponsor"}
                        </h4>

                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">

                                <div className="col-md-6">
                                    <label>Category</label>
                                    <select
                                        className="form-control"
                                        name="category"
                                        value={formData.category}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map((cat) => (
                                            <option key={cat.id} value={cat.id}>
                                                {cat.type}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label>Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="file"
                                        onChange={handleChange}
                                        ref={fileInputRef}
                                    />
                                </div>
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">{sponsorId ? "Update" : "Submit"}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default YclSponsors;
